import { DeleteOutlined, LoadingOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import { RcFile } from 'rc-upload/lib/interface';
import { FC } from 'react';
import MinUploadIcon from '../../assets/images/catalogue/minUploadIcon';

interface IMinUploadImg {
  imgUrl?: string;
  changeFile?: (file: string | Blob | RcFile) => void;
  deleteImg?: () => void;
  loading?: boolean;
  diff: string;
}

const MinUpLoadImg: FC<IMinUploadImg> = ({ imgUrl, changeFile, loading, diff, deleteImg }: IMinUploadImg) => {
  let container = document.getElementById(`deleteItem${diff}`);
  let show = document.getElementById(`showContainer${diff}`);
  if (container && show) {
    container.addEventListener('mouseover', function () {
      if (show) {
        show.style.display = 'block';
      }
    });

    container.addEventListener('mouseout', function () {
      if (show) {
        show.style.display = 'none';
      }
    });
  }

  const handleDelete = () => {
    if (deleteImg) {
      deleteImg();
    }
  };

  const myFile = (file: string | Blob | RcFile) => {
    if (changeFile) {
      changeFile(file);
    }
  };

  return (
    <div id="minUpload">
      {loading ? (
        <div>
          <LoadingOutlined className="sizeLoading" />
        </div>
      ) : (
        <>
          {imgUrl ? (
            <div className="containerData">
              <div className="containerImg" id={`deleteItem${diff}`}>
                <div className="imgOver" id={`showContainer${diff}`}>
                  <DeleteOutlined
                    className="iconDelete"
                    onClick={() => {
                      handleDelete();
                    }}
                  />
                </div>
                <img alt="min-img" src={imgUrl} className="positionImg" />
              </div>
            </div>
          ) : (
            <Upload
              showUploadList={false}
              customRequest={e => {
                if (e.file) {
                  myFile(e.file);
                }
              }}
            >
              <div className="containerData">
                <div className="minText">Foto (Opcional)</div>
                <MinUploadIcon className="m-auto block" />
              </div>
            </Upload>
          )}
        </>
      )}
    </div>
  );
};
export default MinUpLoadImg;
